import { useMutation, useQuery } from "@tanstack/react-query"
import client from "../api/client"

export const useRegister = () => {
  return useMutation({
    mutationFn: (data) => client.post("/auth/register", data)
  })
}

export const useLogin = () => {
  return useMutation({
    mutationFn: (data) => client.post("/auth/login", data)
  })
}

export const useLogout = () => {
  return () => {
    localStorage.removeItem("token")
    localStorage.removeItem("user")
  }
}

export const useUser = () => {
  return useQuery({
    queryKey: ["user"],
    queryFn: () => client.get("/users/profile"),
    enabled: !!localStorage.getItem("token"),
  })
}
